import { Box, Center, ThemeIcon, Text, Button } from '@mantine/core'
import ModalHeader from '../shared/ModalHeader/ModalHeader'
import {
    X,
} from 'lucide-react'
import { useListStockAlerts } from '@/contexts/alerts-context'

export const Title = () => {
    const metadata = {
        title: 'Oups!',
        description:
            'Une erreur est survenue lors de la récupération de votre panier.',
    }
    return <ModalHeader {...metadata} />
}


const CART_KEY = 'medusa_cart_id'

export const View = () => {
    return (
        <Box className="h-full w-full">
            <Center className="flex-col h-full text-center gap-y-4">
                <ThemeIcon color="red" variant="light" size="xl">
                    <X className="w-4 h-4" />
                </ThemeIcon>
                <Text size="sm" c="gray.6">
                    Nous n'avons pas pu récupérer votre panier.
                    <br />
                    Nous vous invitons à rafraichîr la page ou à contacter notre
                    service client si le problème persiste.
                </Text>
                <Button
                    onClick={() =>{ localStorage.removeItem(CART_KEY); window.location.reload()}}
                    size="sm"
                    color="gray"
                    variant="outline"
                >
                    Rafraîchir la page
                </Button>
            </Center>
        </Box>
    )
}
